
	/*!
  * tiptap vundefined
  * (c) 2018 Scrumpy UG (limited liability)
  * @license MIT
  */

import { Node, Plugin, Mark, Extension } from 'tiptap';
import { wrappingInputRule, toggleWrap, toggleList, toggleBlockType, setBlockType, textblockTypeInputRule, chainCommands, exitCode, splitListItem, liftListItem, sinkListItem, insertText, replaceText, splitToDefaultListItem, wrapInList, toggleMark, markInputRule, updateMark, removeMark } from 'tiptap-commands';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { findBlockNodes } from 'prosemirror-utils';
import low from 'lowlight/lib/core';
import { Plugin as Plugin$1, PluginKey } from 'prosemirror-state';
import { history, undo, redo } from 'prosemirror-history';

var BlockquoteNode = (function (Node$$1) {
	function BlockquoteNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) BlockquoteNode.__proto__ = Node$$1;
	BlockquoteNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	BlockquoteNode.prototype.constructor = BlockquoteNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'blockquote'
	};

	prototypeAccessors.schema.get = function () {
		return {
			content: 'block*',
			group: 'block',
			defining: true,
			draggable: false,
			parseDOM: [
				{ tag: 'blockquote' } ],
			toDOM: function () { return ['blockquote', 0]; },
		}
	};

	BlockquoteNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return toggleWrap(type, schema.nodes.paragraph)
	};

	BlockquoteNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Ctrl->': toggleWrap(type),
		}
	};

	BlockquoteNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			wrappingInputRule(/^\s*>\s$/, type) ]
	};

	Object.defineProperties( BlockquoteNode.prototype, prototypeAccessors );

	return BlockquoteNode;
}(Node));

var BulletNode = (function (Node$$1) {
	function BulletNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) BulletNode.__proto__ = Node$$1;
	BulletNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	BulletNode.prototype.constructor = BulletNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'bullet_list'
	};

	prototypeAccessors.schema.get = function () {
		return {
			content: 'list_item+',
			group: 'block',
			parseDOM: [
				{ tag: 'ul' } ],
			toDOM: function () { return ['ul', 0]; },
		}
	};

	BulletNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return toggleList(type, schema.nodes.list_item)
	};

	BulletNode.prototype.keys = function keys (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return {
			'Shift-Ctrl-8': toggleList(type, schema.nodes.list_item),
		}
	};

	BulletNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			wrappingInputRule(/^\s*([-+*])\s$/, type) ]
	};

	Object.defineProperties( BulletNode.prototype, prototypeAccessors );

	return BulletNode;
}(Node));

var CodeBlockNode = (function (Node$$1) {
	function CodeBlockNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) CodeBlockNode.__proto__ = Node$$1;
	CodeBlockNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	CodeBlockNode.prototype.constructor = CodeBlockNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'code_block'
	};

	prototypeAccessors.schema.get = function () {
		return {
			content: 'text*',
			marks: '',
			group: 'block',
			code: true,
			defining: true,
			draggable: false,
			parseDOM: [
				{ tag: 'pre', preserveWhitespace: 'full' } ],
			toDOM: function () { return ['pre', ['code', 0]]; },
		}
	};

	CodeBlockNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return toggleBlockType(type, schema.nodes.paragraph)
	};

	CodeBlockNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Shift-Ctrl-\\': setBlockType(type),
		}
	};

	CodeBlockNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			textblockTypeInputRule(/^```$/, type) ]
	};

	Object.defineProperties( CodeBlockNode.prototype, prototypeAccessors );

	return CodeBlockNode;
}(Node));

function getDecorations(doc) {
	var decorations = [];

	var blocks = findBlockNodes(doc)
		.filter(function (item) { return item.node.type.name === 'code_block'; });

	var flatten = function (list) { return list.reduce(
		function (a, b) { return a.concat(Array.isArray(b) ? flatten(b) : b); }, []
		); };

	function parseNodes(nodes, className) {
		if ( className === void 0 ) className = [];

		return nodes.map(function (node) {

			var classes = className.concat( node.properties ? node.properties.className : [] );

			if (node.children) {
				return parseNodes(node.children, classes)
			}

			return {
				text: node.value,
				classes: classes,
			}
		})
	}

	blocks.forEach(function (block) {
		var startPos = block.pos + 1;
		var nodes = low.highlightAuto(block.node.textContent).value;

		flatten(parseNodes(nodes))
			.map(function (node) {
				var from = startPos;
				var to = from + node.text.length;

				startPos = to;

				return Object.assign({}, node,
					{from: from,
					to: to})
			})
			.forEach(function (node) {
				var decoration = Decoration.inline(node.from, node.to, {
					class: node.classes.join(' '),
				});
				decorations.push(decoration);
			});
	});

	return DecorationSet.create(doc, decorations)
}

var CodeBlockHighlightNode = (function (Node$$1) {
	function CodeBlockHighlightNode(options) {
		if ( options === void 0 ) options = {};

		Node$$1.call(this, options);
		try {
			Object.entries(this.options.languages).forEach(function (ref) {
				var name = ref[0];
				var mapping = ref[1];

				low.registerLanguage(name, mapping);
			});
		} catch (err) {
			throw new Error('Invalid syntax highlight definitions: define at least one highlight.js language mapping')
		}
	}

	if ( Node$$1 ) CodeBlockHighlightNode.__proto__ = Node$$1;
	CodeBlockHighlightNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	CodeBlockHighlightNode.prototype.constructor = CodeBlockHighlightNode;

	var prototypeAccessors = { defaultOptions: { configurable: true },name: { configurable: true },schema: { configurable: true },plugins: { configurable: true } };

	prototypeAccessors.defaultOptions.get = function () {
		return {
			languages: {},
		}
	};

	prototypeAccessors.name.get = function () {
		return 'code_block'
	};

	prototypeAccessors.schema.get = function () {
		return {
			content: 'text*',
			marks: '',
			group: 'block',
			code: true,
			defining: true,
			draggable: false,
			parseDOM: [
				{ tag: 'pre', preserveWhitespace: 'full' } ],
			toDOM: function () { return ['pre', ['code', 0]]; },
		}
	};

	CodeBlockHighlightNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return toggleBlockType(type, schema.nodes.paragraph)
	};

	CodeBlockHighlightNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Shift-Ctrl-\\': setBlockType(type),
		}
	};

	CodeBlockHighlightNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			textblockTypeInputRule(/^```$/, type) ]
	};

	prototypeAccessors.plugins.get = function () {
		return [
			new Plugin({
				state: {
					init: function init(_, ref) {
						var doc = ref.doc;

						return getDecorations(doc)
					},
					apply: function apply(tr, set) {
						// TODO: find way to cache decorations
						// see: https://discuss.prosemirror.net/t/how-to-update-multiple-inline-decorations-on-node-change/1493
						if (tr.docChanged) {
							return getDecorations(tr.doc)
						}
						return set.map(tr.mapping, tr.doc)
					},
				},
				props: {
					decorations: function decorations(state) {
						return this.getState(state)
					},
				},
			}) ]
	};

	Object.defineProperties( CodeBlockHighlightNode.prototype, prototypeAccessors );

	return CodeBlockHighlightNode;
}(Node));

var HardBreakNode = (function (Node$$1) {
	function HardBreakNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) HardBreakNode.__proto__ = Node$$1;
	HardBreakNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	HardBreakNode.prototype.constructor = HardBreakNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'hard_break'
	};

	prototypeAccessors.schema.get = function () {
		return {
			inline: true,
			group: 'inline',
			selectable: false,
			parseDOM: [
				{ tag: 'br' } ],
			toDOM: function () { return ['br']; },
		}
	};

	HardBreakNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		var command = chainCommands(exitCode, function (state, dispatch) {
			dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
			return true
		});
		return {
			'Mod-Enter': command,
			'Shift-Enter': command,
		}
	};

	Object.defineProperties( HardBreakNode.prototype, prototypeAccessors );

	return HardBreakNode;
}(Node));

var HeadingNode = (function (Node$$1) {
	function HeadingNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) HeadingNode.__proto__ = Node$$1;
	HeadingNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	HeadingNode.prototype.constructor = HeadingNode;

	var prototypeAccessors = { name: { configurable: true },defaultOptions: { configurable: true },levels: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'heading'
	};

	prototypeAccessors.defaultOptions.get = function () {
		return {
			maxLevel: 6,
		}
	};

	prototypeAccessors.levels.get = function () {
		return Array.from(new Array(this.options.maxLevel), function (value, index) { return index + 1; })
	};

	prototypeAccessors.schema.get = function () {
		return {
			attrs: {
				level: {
					default: 1,
				},
			},
			content: 'inline*',
			group: 'block',
			defining: true,
			draggable: false,
			parseDOM: this.levels.map(function (level) { return ({ tag: ("h" + level), attrs: { level: level } }); }),
			toDOM: function (node) { return [("h" + (node.attrs.level)), 0]; },
		}
	};

	HeadingNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;
		var attrs = ref.attrs;

		return toggleBlockType(type, schema.nodes.paragraph, attrs)
	};

	HeadingNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return this.levels.reduce(function (items, level) {
			var obj;

			return (Object.assign({}, items,
			( obj = {}, obj[("Shift-Ctrl-" + level)] = setBlockType(type, { level: level }), obj )));
		}, {})
	};

	HeadingNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			textblockTypeInputRule(
				new RegExp(("^(#{1," + (this.options.maxLevel) + "})\\s$")),
				type,
				function (match) { return ({ level: match[1].length }); }
			) ]
	};

	Object.defineProperties( HeadingNode.prototype, prototypeAccessors );

	return HeadingNode;
}(Node));

var ImageNode = (function (Node$$1) {
	function ImageNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) ImageNode.__proto__ = Node$$1;
	ImageNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	ImageNode.prototype.constructor = ImageNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true },plugins: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'image'
	};

	prototypeAccessors.schema.get = function () {
		return {
			inline: true,
			attrs: {
				src: {},
				alt: {
					default: null,
				},
				title: {
					default: null,
				},
			},
			group: 'inline',
			draggable: true,
			parseDOM: [
				{
					tag: 'img[src]',
					getAttrs: function (dom) { return ({
						src: dom.getAttribute('src'),
						title: dom.getAttribute('title'),
						alt: dom.getAttribute('alt'),
					}); },
				} ],
			toDOM: function (node) { return ['img', node.attrs]; },
		}
	};

	ImageNode.prototype.command = function command (ref) {
		var type = ref.type;
		var attrs = ref.attrs;

		return function (state, dispatch) {
			var selection = state.selection;
			var position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
			var node = type.create(attrs);
			var transaction = state.tr.insert(position, node);
			dispatch(transaction);
		}
	};

	prototypeAccessors.plugins.get = function () {
		return [
			new Plugin({
				props: {
					handleDOMEvents: {
						drop: function drop(view, event) {
							var hasFiles = event.dataTransfer
							&& event.dataTransfer.files
							&& event.dataTransfer.files.length;

							if (!hasFiles) {
								return
							}

							var images = Array
								.from(event.dataTransfer.files)
								.filter(function (file) { return (/image/i).test(file.type); });

							if (images.length === 0) {
								return
							}

							event.preventDefault();

							var ref = view.state;
							var schema = ref.schema;
							var coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY });

							images.forEach(function (image) {
								var reader = new FileReader();

								reader.onload = function (readerEvent) {
									var node = schema.nodes.image.create({
										src: readerEvent.target.result,
									});
									var transaction = view.state.tr.insert(coordinates.pos, node);
									view.dispatch(transaction);
								};
								reader.readAsDataURL(image);
							});
						},
					},
				},
			}) ]
	};

	Object.defineProperties( ImageNode.prototype, prototypeAccessors );

	return ImageNode;
}(Node));

var ListItemNode = (function (Node$$1) {
	function ListItemNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) ListItemNode.__proto__ = Node$$1;
	ListItemNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	ListItemNode.prototype.constructor = ListItemNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'list_item'
	};

	prototypeAccessors.schema.get = function () {
		return {
			content: 'paragraph block*',
			group: 'block',
			defining: true,
			draggable: false,
			parseDOM: [
				{ tag: 'li' } ],
			toDOM: function () { return ['li', 0]; },
		}
	};

	ListItemNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			Enter: splitListItem(type),
			Tab: sinkListItem(type),
			'Shift-Tab': liftListItem(type),
		}
	};

	Object.defineProperties( ListItemNode.prototype, prototypeAccessors );

	return ListItemNode;
}(Node));

// Create a matcher that matches when a specific character is typed. Useful for @mentions and #tags.
function triggerCharacter(ref) {
	var char = ref.char; if ( char === void 0 ) char = '@';
	var allowSpaces = ref.allowSpaces; if ( allowSpaces === void 0 ) allowSpaces = false;
	var startOfLine = ref.startOfLine; if ( startOfLine === void 0 ) startOfLine = false;


	return function ($position) {
		// Matching expressions used for later
		var suffix = new RegExp(("\\s" + char + "$"));
		var prefix = startOfLine ? '^' : '';
		var regexp = allowSpaces
			? new RegExp(("" + prefix + char + ".*?(?=\\s" + char + "|$)"), 'gm')
			: new RegExp((prefix + "(?:^)?" + char + "[^\\s" + char + "]*"), 'gm');

		// Lookup the boundaries of the current node
		var textFrom = $position.before();
		var textTo = $position.end();
		var text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');

        var match = regexp.exec(text);
        var position;
		while (match !== null) {
            // JavaScript doesn't have lookbehinds; this hacks a check that first character is " "
            // or the line beginning
			var matchPrefix = match.input.slice(Math.max(0, match.index - 1), match.index);
			if (/^[\s\0]?$/.test(matchPrefix)) {
                // The absolute position of the match in the document
                var from = match.index + $position.start();
                var to = from + match[0].length;

                // Edge case handling; if spaces are allowed and we're directly in between
                // two triggers
                if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
                    match[0] += ' ';
                    to += 1;
                }

                // If the $position is located within the matched substring, return that range
                if (from < $position.pos && to >= $position.pos) {
                    position = {
                        range: {
                            from: from,
                            to: to,
                        },
                        query: match[0].slice(char.length),
                        text: match[0],
                    };
                }
			}
            match = regexp.exec(text);
        }
        return position
	}
}

function SuggestionsPlugin(ref) {
	var matcher = ref.matcher; if ( matcher === void 0 ) matcher = {
		char: '@',
		allowSpaces: false,
		startOfLine: false,
	};
	var appendText = ref.appendText; if ( appendText === void 0 ) appendText = null;
	var suggestionClass = ref.suggestionClass; if ( suggestionClass === void 0 ) suggestionClass = 'suggestion';
	var command = ref.command; if ( command === void 0 ) command = function () { return false; };
	var items = ref.items; if ( items === void 0 ) items = [];
	var onEnter = ref.onEnter; if ( onEnter === void 0 ) onEnter = function () { return false; };
	var onChange = ref.onChange; if ( onChange === void 0 ) onChange = function () { return false; };
	var onExit = ref.onExit; if ( onExit === void 0 ) onExit = function () { return false; };
	var onKeyDown = ref.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = function () { return false; };
	var onFilter = ref.onFilter; if ( onFilter === void 0 ) onFilter = function (searchItems, query) {
		if (!query) {
			return searchItems
		}

		return searchItems
			.filter(function (item) { return JSON.stringify(item).toLowerCase().includes(query.toLowerCase()); })
	};

	return new Plugin$1({
		key: new PluginKey('suggestions'),

		view: function view() {
			var this$1 = this;

			return {
				update: function (view, prevState) {
					var prev = this$1.key.getState(prevState);
					var next = this$1.key.getState(view.state);

					// See how the state changed
					var moved = prev.active && next.active && prev.range.from !== next.range.from;
					var started = !prev.active && next.active;
					var stopped = prev.active && !next.active;
					var changed = !started && !stopped && prev.query !== next.query;
					var handleStart = started || moved;
					var handleChange = changed && !moved;
					var handleExit = stopped || moved;

					// Cancel when suggestion isn't active
					if (!handleStart && !handleChange && !handleExit) {
						return
					}

					var state = handleExit ? prev : next;
					var decorationNode = document.querySelector(("[data-decoration-id=\"" + (state.decorationId) + "\"]"));

					// build a virtual node for popper.js or tippy.js
					// this can be used for building popups without a DOM node
					var virtualNode = decorationNode ? {
						getBoundingClientRect: function getBoundingClientRect() {
							return decorationNode.getBoundingClientRect()
						},
						clientWidth: decorationNode.clientWidth,
						clientHeight: decorationNode.clientHeight,
					} : null;

					var props = {
						view: view,
						range: state.range,
						query: state.query,
						text: state.text,
						decorationNode: decorationNode,
						virtualNode: virtualNode,
						items: onFilter(items, state.query),
						command: function (ref) {
							var range = ref.range;
							var attrs = ref.attrs;

							command({
								range: range,
								attrs: attrs,
								schema: view.state.schema,
							})(view.state, view.dispatch, view);

							if (appendText) {
								insertText(appendText)(view.state, view.dispatch, view);
							}
						},
					};

					// Trigger the hooks when necessary
					if (handleExit) {
						onExit(props);
					}

					if (handleChange) {
						onChange(props);
					}

					if (handleStart) {
						onEnter(props);
					}
				},
			}
		},

		state: {

			// Initialize the plugin's internal state.
			init: function init() {
				return {
					active: false,
					range: {},
					query: null,
					text: null,
				}
			},

			// Apply changes to the plugin state from a view transaction.
			apply: function apply(tr, prev) {
				var selection = tr.selection;
				var next = Object.assign({}, prev);

				// We can only be suggesting if there is no selection
				if (selection.from === selection.to) {
					// Reset active state if we just left the previous suggestion range
					if (selection.from < prev.range.from || selection.from > prev.range.to) {
						next.active = false;
					}

					// Try to match against where our cursor currently is
					var $position = selection.$from;
					var match = triggerCharacter(matcher)($position);
					var decorationId = (Math.random() + 1).toString(36).substr(2, 5);

					// If we found a match, update the current state to show it
					if (match) {
						next.active = true;
						next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
						next.range = match.range;
						next.query = match.query;
						next.text = match.text;
					} else {
						next.active = false;
					}
				} else {
					next.active = false;
				}

				// Make sure to empty the range if suggestion is inactive
				if (!next.active) {
					next.decorationId = null;
					next.range = {};
					next.query = null;
					next.text = null;
				}

				return next
			},
		},

		props: {

			// Call the keydown hook if suggestion is active.
			handleKeyDown: function handleKeyDown(view, event) {
				var ref = this.getState(view.state);
				var active = ref.active;
				var range = ref.range;

				if (!active) { return false }

				return onKeyDown({ view: view, event: event, range: range })
			},

			// Setup decorator on the currently active suggestion.
			decorations: function decorations(editorState) {
				var ref = this.getState(editorState);
				var active = ref.active;
				var range = ref.range;
				var decorationId = ref.decorationId;

				if (!active) { return null }

				return DecorationSet.create(editorState.doc, [
					Decoration.inline(range.from, range.to, {
						nodeName: 'span',
						class: suggestionClass,
						'data-decoration-id': decorationId,
					}) ])
			},
		},
	})
}

var MentionNode = (function (Node$$1) {
	function MentionNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) MentionNode.__proto__ = Node$$1;
	MentionNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	MentionNode.prototype.constructor = MentionNode;

	var prototypeAccessors = { name: { configurable: true },defaultOptions: { configurable: true },schema: { configurable: true },plugins: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'mention'
	};

	prototypeAccessors.defaultOptions.get = function () {
		return {
			matcher: {
				char: '@',
				allowSpaces: false,
				startOfLine: false,
			},
			mentionClass: 'mention',
			suggestionClass: 'mention-suggestion',
		}
	};

	prototypeAccessors.schema.get = function () {
		var this$1 = this;

		return {
			attrs: {
				id: {},
				label: {},
			},
			group: 'inline',
			inline: true,
			selectable: false,
			atom: true,
			toDOM: function (node) { return [
				'span',
				{
					class: this$1.options.mentionClass,
					'data-mention-id': node.attrs.id,
				},
				("" + (this$1.options.matcher.char) + (node.attrs.label)) ]; },
			parseDOM: [
				{
					tag: 'span[data-mention-id]',
					getAttrs: function (dom) {
						var id = dom.getAttribute('data-mention-id');
						var label = dom.innerText.split(this$1.options.matcher.char).join('');
						return { id: id, label: label }
					},
				} ],
		}
	};

	prototypeAccessors.plugins.get = function () {
		return [
			SuggestionsPlugin({
				command: function (ref) {
					var range = ref.range;
					var attrs = ref.attrs;
					var schema = ref.schema;

					return replaceText(range, schema.nodes.mention, attrs);
		},
				appendText: ' ',
				matcher: this.options.matcher,
				items: this.options.items,
				onEnter: this.options.onEnter,
				onChange: this.options.onChange,
				onExit: this.options.onExit,
				onKeyDown: this.options.onKeyDown,
				onFilter: this.options.onFilter,
				suggestionClass: this.options.suggestionClass,
			}) ]
	};

	Object.defineProperties( MentionNode.prototype, prototypeAccessors );

	return MentionNode;
}(Node));

var OrderedListNode = (function (Node$$1) {
	function OrderedListNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) OrderedListNode.__proto__ = Node$$1;
	OrderedListNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	OrderedListNode.prototype.constructor = OrderedListNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'ordered_list'
	};

	prototypeAccessors.schema.get = function () {
		return {
			attrs: {
				order: {
					default: 1,
				},
			},
			content: 'list_item+',
			group: 'block',
			parseDOM: [
				{
					tag: 'ol',
					getAttrs: function (dom) { return ({
						order: dom.hasAttribute('start') ? +dom.getAttribute('start') : 1,
					}); },
				} ],
			toDOM: function (node) { return (node.attrs.order === 1 ? ['ol', 0] : ['ol', { start: node.attrs.order }, 0]); },
		}
	};

	OrderedListNode.prototype.command = function command (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return toggleList(type, schema.nodes.list_item)
	};

	OrderedListNode.prototype.keys = function keys (ref) {
		var type = ref.type;
		var schema = ref.schema;

		return {
			'Shift-Ctrl-9': toggleList(type, schema.nodes.list_item),
		}
	};

	OrderedListNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			wrappingInputRule(
				/^(\d+)\.\s$/,
				type,
				function (match) { return ({ order: +match[1] }); },
				function (match, node) { return node.childCount + node.attrs.order === +match[1]; }
			) ]
	};

	Object.defineProperties( OrderedListNode.prototype, prototypeAccessors );

	return OrderedListNode;
}(Node));

var TodoItemNode = (function (Node$$1) {
	function TodoItemNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) TodoItemNode.__proto__ = Node$$1;
	TodoItemNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	TodoItemNode.prototype.constructor = TodoItemNode;

	var prototypeAccessors = { name: { configurable: true },view: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'todo_item'
	};

	prototypeAccessors.view.get = function () {
		return {
			props: ['node', 'updateAttrs', 'editable'],
			methods: {
				onChange: function onChange() {
					this.updateAttrs({
						done: !this.node.attrs.done,
					});
				},
			},
			template: "\n\t\t\t\t<li data-type=\"todo_item\" :data-done=\"node.attrs.done.toString()\">\n\t\t\t\t\t<span class=\"todo-checkbox\" contenteditable=\"false\" @click=\"onChange\"></span>\n\t\t\t\t\t<div class=\"todo-content\" ref=\"content\" :contenteditable=\"editable.toString()\"></div>\n\t\t\t\t</li>\n\t\t\t",
		}
	};

	prototypeAccessors.schema.get = function () {
		return {
			attrs: {
				done: {
					default: false,
				},
			},
			draggable: false,
			content: 'paragraph',
			toDOM: function toDOM(node) {
				var ref = node.attrs;
				var done = ref.done;

				return ['li', {
						'data-type': 'todo_item',
						'data-done': done.toString(),
					},
					['span', { class: 'todo-checkbox', contenteditable: 'false' }],
					['div', { class: 'todo-content' }, 0] ]
			},
			parseDOM: [{
				priority: 51,
				tag: '[data-type="todo_item"]',
				getAttrs: function (dom) { return ({
					done: dom.getAttribute('data-done') === 'true',
				}); },
			}],
		}
	};

	TodoItemNode.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			Enter: splitToDefaultListItem(type),
			'Shift-Tab': liftListItem(type),
		}
	};

	Object.defineProperties( TodoItemNode.prototype, prototypeAccessors );

	return TodoItemNode;
}(Node));

var TodoListNode = (function (Node$$1) {
	function TodoListNode () {
		Node$$1.apply(this, arguments);
	}

	if ( Node$$1 ) TodoListNode.__proto__ = Node$$1;
	TodoListNode.prototype = Object.create( Node$$1 && Node$$1.prototype );
	TodoListNode.prototype.constructor = TodoListNode;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'todo_list'
	};

	prototypeAccessors.schema.get = function () {
		return {
			group: 'block',
			content: 'todo_item+',
			toDOM: function () { return ['ul', { 'data-type': 'todo_list' }, 0]; },
			parseDOM: [{
				priority: 51,
				tag: '[data-type="todo_list"]',
			}],
		}
	};

	TodoListNode.prototype.command = function command (ref) {
		var type = ref.type;

		return wrapInList(type)
	};

	TodoListNode.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			wrappingInputRule(/^\s*(\[ \])\s$/, type) ]
	};

	Object.defineProperties( TodoListNode.prototype, prototypeAccessors );

	return TodoListNode;
}(Node));

var BoldMark = (function (Mark$$1) {
	function BoldMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) BoldMark.__proto__ = Mark$$1;
	BoldMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	BoldMark.prototype.constructor = BoldMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'bold'
	};

	prototypeAccessors.schema.get = function () {
		return {
			parseDOM: [
				{
					tag: 'strong',
				},
				{
					tag: 'b',
					getAttrs: function (node) { return node.style.fontWeight !== 'normal' && null; },
				},
				{
					style: 'font-weight',
					getAttrs: function (value) { return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null; },
				} ],
			toDOM: function () { return ['strong', 0]; },
		}
	};

	BoldMark.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Mod-b': toggleMark(type),
		}
	};

	BoldMark.prototype.command = function command (ref) {
		var type = ref.type;

		return toggleMark(type)
	};

	BoldMark.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type) ]
	};

	Object.defineProperties( BoldMark.prototype, prototypeAccessors );

	return BoldMark;
}(Mark));

var CodeMark = (function (Mark$$1) {
	function CodeMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) CodeMark.__proto__ = Mark$$1;
	CodeMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	CodeMark.prototype.constructor = CodeMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'code'
	};

	prototypeAccessors.schema.get = function () {
		return {
			parseDOM: [
				{ tag: 'code' } ],
			toDOM: function () { return ['code', 0]; },
		}
	};

	CodeMark.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Mod-`': toggleMark(type),
		}
	};

	CodeMark.prototype.command = function command (ref) {
		var type = ref.type;

		return toggleMark(type)
	};

	CodeMark.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			markInputRule(/(?:`)([^`]+)(?:`)$/, type) ]
	};

	Object.defineProperties( CodeMark.prototype, prototypeAccessors );

	return CodeMark;
}(Mark));

var ItalicMark = (function (Mark$$1) {
	function ItalicMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) ItalicMark.__proto__ = Mark$$1;
	ItalicMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	ItalicMark.prototype.constructor = ItalicMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'italic'
	};

	prototypeAccessors.schema.get = function () {
		return {
			parseDOM: [
				{ tag: 'i' },
				{ tag: 'em' },
				{ style: 'font-style=italic' } ],
			toDOM: function () { return ['em', 0]; },
		}
	};

	ItalicMark.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Mod-i': toggleMark(type),
		}
	};

	ItalicMark.prototype.command = function command (ref) {
		var type = ref.type;

		return toggleMark(type)
	};

	ItalicMark.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			markInputRule(/(?:^|[^*_])(?:\*|_)([^*_]+)(?:\*|_)$/, type) ]
	};

	Object.defineProperties( ItalicMark.prototype, prototypeAccessors );

	return ItalicMark;
}(Mark));

var LinkMark = (function (Mark$$1) {
	function LinkMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) LinkMark.__proto__ = Mark$$1;
	LinkMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	LinkMark.prototype.constructor = LinkMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'link'
	};

	prototypeAccessors.schema.get = function () {
		return {
			attrs: {
				href: {
					default: null,
				},
			},
			inclusive: false,
			parseDOM: [
				{
					tag: 'a[href]',
					getAttrs: function (dom) { return ({
						href: dom.getAttribute('href'),
					}); },
				} ],
			toDOM: function (node) { return ['a', Object.assign({}, node.attrs,
				{rel: 'noopener noreferrer nofollow'}), 0]; },
		}
	};

	LinkMark.prototype.command = function command (ref) {
		var type = ref.type;
		var attrs = ref.attrs;

		if (attrs.href) {
			return updateMark(type, attrs)
		}

		return removeMark(type)
	};

	Object.defineProperties( LinkMark.prototype, prototypeAccessors );

	return LinkMark;
}(Mark));

var StrikeMark = (function (Mark$$1) {
	function StrikeMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) StrikeMark.__proto__ = Mark$$1;
	StrikeMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	StrikeMark.prototype.constructor = StrikeMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'strike'
	};

	prototypeAccessors.schema.get = function () {
		return {
			parseDOM: [
				{
					tag: 's',
				},
				{
					tag: 'del',
				},
				{
					tag: 'strike',
				},
				{
					style: 'text-decoration',
					getAttrs: function (value) { return value === 'line-through'; },
				} ],
			toDOM: function () { return ['s', 0]; },
		}
	};

	StrikeMark.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Mod-d': toggleMark(type),
		}
	};

	StrikeMark.prototype.command = function command (ref) {
		var type = ref.type;

		return toggleMark(type)
	};

	StrikeMark.prototype.inputRules = function inputRules (ref) {
		var type = ref.type;

		return [
			markInputRule(/~([^~]+)~$/, type) ]
	};

	Object.defineProperties( StrikeMark.prototype, prototypeAccessors );

	return StrikeMark;
}(Mark));

var UnderlineMark = (function (Mark$$1) {
	function UnderlineMark () {
		Mark$$1.apply(this, arguments);
	}

	if ( Mark$$1 ) UnderlineMark.__proto__ = Mark$$1;
	UnderlineMark.prototype = Object.create( Mark$$1 && Mark$$1.prototype );
	UnderlineMark.prototype.constructor = UnderlineMark;

	var prototypeAccessors = { name: { configurable: true },schema: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'underline'
	};

	prototypeAccessors.schema.get = function () {
		return {
			parseDOM: [
				{
					tag: 'u',
				},
				{
					style: 'text-decoration',
					getAttrs: function (value) { return value === 'underline'; },
				} ],
			toDOM: function () { return ['u', 0]; },
		}
	};

	UnderlineMark.prototype.keys = function keys (ref) {
		var type = ref.type;

		return {
			'Mod-u': toggleMark(type),
		}
	};

	UnderlineMark.prototype.command = function command (ref) {
		var type = ref.type;

		return toggleMark(type)
	};

	Object.defineProperties( UnderlineMark.prototype, prototypeAccessors );

	return UnderlineMark;
}(Mark));

var HistoryExtension = (function (Extension$$1) {
	function HistoryExtension () {
		Extension$$1.apply(this, arguments);
	}

	if ( Extension$$1 ) HistoryExtension.__proto__ = Extension$$1;
	HistoryExtension.prototype = Object.create( Extension$$1 && Extension$$1.prototype );
	HistoryExtension.prototype.constructor = HistoryExtension;

	var prototypeAccessors = { name: { configurable: true },plugins: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'history'
	};

	HistoryExtension.prototype.keys = function keys () {
		var isMac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
		var keymap = {
			'Mod-z': undo,
			'Shift-Mod-z': redo,
		};

		if (!isMac) {
			keymap['Mod-y'] = redo;
		}

		return keymap
	};

	prototypeAccessors.plugins.get = function () {
		return [
			history() ]
	};

	Object.defineProperties( HistoryExtension.prototype, prototypeAccessors );

	return HistoryExtension;
}(Extension));

var PlaceholderExtension = (function (Extension$$1) {
	function PlaceholderExtension () {
		Extension$$1.apply(this, arguments);
	}

	if ( Extension$$1 ) PlaceholderExtension.__proto__ = Extension$$1;
	PlaceholderExtension.prototype = Object.create( Extension$$1 && Extension$$1.prototype );
	PlaceholderExtension.prototype.constructor = PlaceholderExtension;

	var prototypeAccessors = { name: { configurable: true },defaultOptions: { configurable: true },plugins: { configurable: true } };

	prototypeAccessors.name.get = function () {
		return 'placeholder'
	};

	prototypeAccessors.defaultOptions.get = function () {
		return {
			emptyNodeClass: 'is-empty',
		}
	};

	prototypeAccessors.plugins.get = function () {
		var this$1 = this;

		return [
			new Plugin({
				props: {
					decorations: function (ref) {
						var doc = ref.doc;

						var decorations = [];
						var completelyEmpty = doc.textContent === '' && doc.childCount <= 1 && doc.content.size <= 2;

						doc.descendants(function (node, pos) {
							if (!completelyEmpty) {
								return
							}

							var decoration = Decoration.node(pos, pos + node.nodeSize, {
								class: this$1.options.emptyNodeClass,
							});
							decorations.push(decoration);
						});

						return DecorationSet.create(doc, decorations)
					},
				},
			}) ]
	};

	Object.defineProperties( PlaceholderExtension.prototype, prototypeAccessors );

	return PlaceholderExtension;
}(Extension));

export { BlockquoteNode, BulletNode as BulletListNode, CodeBlockNode, CodeBlockHighlightNode, HardBreakNode, HeadingNode, ImageNode, ListItemNode, MentionNode, OrderedListNode, TodoItemNode, TodoListNode, BoldMark, CodeMark, ItalicMark, LinkMark, StrikeMark, UnderlineMark, HistoryExtension, PlaceholderExtension, SuggestionsPlugin };
